export const FIVE_MINUTES_IN_SECONDS = 300000;
